import { useEffect } from "react";
import { useParams, useNavigate, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { SUPPORTED_LANGS } from "../i18n";

function LangWrapper() {
  const { lang } = useParams();
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!SUPPORTED_LANGS.includes(lang)) {
      navigate("/", { replace: true });
      return;
    }
    i18n.changeLanguage(lang);
    Cookies.set("lang", lang, { expires: 365 });
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang, i18n, navigate]);

  if (!SUPPORTED_LANGS.includes(lang)) return null;

  return <Outlet />;
}

export default LangWrapper;
